import axios, { AxiosRequestConfig } from "axios";
import { appSession } from "../TR3AD.ts";

export interface IAPIResponse<T = unknown>
{
    data: T;
    status: number;
    headers: unknown;
    config: AxiosRequestConfig;
}

export default class APIBase
{
    constructor() {}

    /**
     * Constructs the full service URL
     */
    protected buildURL(useAuth:boolean, servicePath: string): string
    {
        if (useAuth)
        {
            return `${import.meta.env.VITE_AUTH_ROOT}${servicePath}`;
        }
        return `${import.meta.env.VITE_API_ROOT}${servicePath}`;
    }

    async get<T = unknown>(serviceURL: string, includeSAH:boolean = true): Promise<IAPIResponse<T>>
    {
        console.log(`APIBase::GET::${serviceURL}`);

        try
        {
            const headers = appSession.createRequestHeader(includeSAH);
            const response = await axios.get<T>(serviceURL, headers);
            return response;
        }
        catch (error: unknown)
        {
            return Promise.reject(error);
        }
    }

    async post<T = unknown>(serviceURL: string, payload: unknown, includeSAH:boolean = true): Promise<IAPIResponse<T>>
    {
        console.log(`APIBase::POST::${serviceURL}`);

        try
        {
            const headers = appSession.createRequestHeader(includeSAH);
            const response = await axios.post<T>(serviceURL, payload, headers);
            return response;
        }
        catch (error: unknown)
        {
            return Promise.reject(error);
        }
    }
}